import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const TransactionsTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [gatewayFilter, setGatewayFilter] = useState('all');

  const [transactions, setTransactions] = useState([
    {
      id: 1,
      transactionId: 'TXN-2026-001234',
      gateway: 'Stripe',
      paymentMethod: 'Credit Card',
      amount: 14999,
      status: 'success',
      failureReason: null,
      timestamp: '2026-02-08 14:23:45'
    },
    {
      id: 2,
      transactionId: 'TXN-2026-001235',
      gateway: 'Razorpay',
      paymentMethod: 'UPI',
      amount: 5999,
      status: 'success',
      failureReason: null,
      timestamp: '2026-02-08 13:15:22'
    },
    {
      id: 3,
      transactionId: 'TXN-2026-001236',
      gateway: 'Stripe',
      paymentMethod: 'Debit Card',
      amount: 2999,
      status: 'failed',
      failureReason: 'Insufficient funds',
      timestamp: '2026-02-08 12:45:10'
    },
    {
      id: 4,
      transactionId: 'TXN-2026-001237',
      gateway: 'Razorpay',
      paymentMethod: 'Net Banking',
      amount: 2999,
      status: 'pending',
      failureReason: null,
      timestamp: '2026-02-08 11:30:05'
    }
  ]);

  const filteredTransactions = transactions?.filter(txn => {
    const matchesSearch = txn?.transactionId?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesStatus = statusFilter === 'all' || txn?.status === statusFilter;
    const matchesGateway = gatewayFilter === 'all' || txn?.gateway === gatewayFilter;
    return matchesSearch && matchesStatus && matchesGateway;
  });

  const getStatusBadge = (status) => {
    const config = {
      success: { bg: 'bg-success/10', text: 'text-success', label: 'Success', icon: 'CheckCircle' },
      failed: { bg: 'bg-destructive/10', text: 'text-destructive', label: 'Failed', icon: 'XCircle' },
      pending: { bg: 'bg-warning/10', text: 'text-warning', label: 'Pending', icon: 'Clock' }
    };
    const statusConfig = config?.[status] || config?.success;
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${statusConfig?.bg} ${statusConfig?.text}`}>
        <Icon name={statusConfig?.icon} size={12} />
        {statusConfig?.label}
      </span>
    );
  };

  return (
    <div className="space-y-6">
      {/* Filters */}
      <div className="bg-card border border-border rounded-lg p-4 md:p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              placeholder="Search transaction ID..."
              className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
            />
          </div>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e?.target?.value)}
            className="px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
          >
            <option value="all">All Status</option>
            <option value="success">Success</option>
            <option value="failed">Failed</option>
            <option value="pending">Pending</option>
          </select>
          <select
            value={gatewayFilter}
            onChange={(e) => setGatewayFilter(e?.target?.value)}
            className="px-4 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50"
          >
            <option value="all">All Gateways</option>
            <option value="Stripe">Stripe</option>
            <option value="Razorpay">Razorpay</option>
          </select>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Transaction ID</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Gateway</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Payment Method</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Amount</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Status</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Failure Reason</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransactions?.map((txn) => (
              <tr key={txn?.id} className="border-b border-border hover:bg-muted/30 transition-smooth">
                <td className="px-4 py-4 font-mono text-sm text-foreground">{txn?.transactionId}</td>
                <td className="px-4 py-4">
                  <span className="inline-flex items-center gap-2 px-2 py-1 bg-muted rounded-md text-sm font-medium text-foreground">
                    <Icon name="CreditCard" size={14} />
                    {txn?.gateway}
                  </span>
                </td>
                <td className="px-4 py-4 text-foreground">{txn?.paymentMethod}</td>
                <td className="px-4 py-4 text-foreground font-semibold">₹{txn?.amount?.toLocaleString()}</td>
                <td className="px-4 py-4">{getStatusBadge(txn?.status)}</td>
                <td className="px-4 py-4 text-foreground">
                  {txn?.failureReason ? (
                    <span className="text-destructive text-sm">{txn?.failureReason}</span>
                  ) : (
                    <span className="text-muted-foreground text-sm">-</span>
                  )}
                </td>
                <td className="px-4 py-4 text-foreground text-sm">{txn?.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="lg:hidden space-y-4">
        {filteredTransactions?.map((txn) => (
          <div key={txn?.id} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="font-mono text-sm font-semibold text-foreground">{txn?.transactionId}</p>
                <p className="text-xs text-muted-foreground mt-1">{txn?.timestamp}</p>
              </div>
              {getStatusBadge(txn?.status)}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-muted-foreground">Gateway</p>
                <p className="text-sm font-medium text-foreground">{txn?.gateway}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Method</p>
                <p className="text-sm font-medium text-foreground">{txn?.paymentMethod}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Amount</p>
                <p className="text-sm font-semibold text-foreground">₹{txn?.amount?.toLocaleString()}</p>
              </div>
              {txn?.failureReason && (
                <div className="col-span-2">
                  <p className="text-xs text-muted-foreground">Failure Reason</p>
                  <p className="text-sm text-destructive">{txn?.failureReason}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransactionsTab;